import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  width: 800px;
  // margin: 16px auto;
`;

export const Lista = styled.ul`
  list-style-type: none;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  li {
    width: 100%;
    margin: 6px;
    text-align: center;
    color: white;
    font-weight: 600;
  }

  li:before {
    content: '';
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: rgba(204, 204, 204, 0.24);
    z-index: 1;
  }

  li:not(:last-child):after {
    content: '';
    display: flex;
    width: 50%;
    height: 2px;
    margin: 0 auto;
    background: repeating-linear-gradient(to right, #e0e0e0 0, #e0e0e0 2px, transparent 0px, transparent 13px);
    transform: translate(100%, -39px);
  }

  li.check:before {
    background-color: #23c265;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='32' height='32' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3E%3Cmetadata%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage'/%3E%3Cdc:title/%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs%3E%3CradialGradient id='rg' cx='297.42' cy='302.6' r='289.78' gradientTransform='matrix(.055214 0 0 .055214 -.42148 -.70772)' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2300af89' offset='0'/%3E%3Cstop stop-color='%2314866d' offset='1'/%3E%3C/radialGradient%3E%3C/defs%3E%3Cpath d='m0 21.826s6.3058 7.2235 7.5648 10.174h5.4191c2.2716-7.0564 11.095-23.898 18.661-29.802 1.5655-2.0495-2.3702-2.8961-5.5477-1.5383-4.7896 2.044-13.821 17.666-15.507 21.422-2.3921 0.64048-4.9155-4.1046-4.9177-4.1046z' fill='url(%23rg)' style='fill:%23f9f9f9;stroke-width:.055214'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 50%;
    background-position: center;
  }

  li.check {
    color: #23c265;
  }

  li.loading:before {
    border: 1px solid #23c265;
    background-color: transparent;
    animation: ${rotate} 1s linear infinite;
    background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.76343 2.125V3.75C7.76343 3.85774 7.72063 3.96108 7.64444 4.03726C7.56825 4.11345 7.46492 4.15625 7.35718 4.15625C7.24943 4.15625 7.1461 4.11345 7.06992 4.03726C6.99373 3.96108 6.95093 3.85774 6.95093 3.75V2.125C6.95093 2.01726 6.99373 1.91392 7.06992 1.83774C7.1461 1.76155 7.24943 1.71875 7.35718 1.71875C7.46492 1.71875 7.56825 1.76155 7.64444 1.83774C7.72063 1.91392 7.76343 2.01726 7.76343 2.125ZM12.2322 6.59375H10.6072C10.4994 6.59375 10.3961 6.63655 10.3199 6.71274C10.2437 6.78892 10.2009 6.89226 10.2009 7C10.2009 7.10774 10.2437 7.21108 10.3199 7.28726C10.3961 7.36345 10.4994 7.40625 10.6072 7.40625H12.2322C12.3399 7.40625 12.4433 7.36345 12.5194 7.28726C12.5956 7.21108 12.6384 7.10774 12.6384 7C12.6384 6.89226 12.5956 6.78892 12.5194 6.71274C12.4433 6.63655 12.3399 6.59375 12.2322 6.59375ZM9.94245 9.01094C9.86564 8.93797 9.76337 8.89789 9.65744 8.89924C9.5515 8.9006 9.45029 8.94328 9.37538 9.0182C9.30046 9.09311 9.25778 9.19432 9.25642 9.30026C9.25506 9.40619 9.29514 9.50847 9.36812 9.58527L10.5168 10.7345C10.593 10.8107 10.6964 10.8535 10.8042 10.8535C10.912 10.8535 11.0154 10.8107 11.0916 10.7345C11.1679 10.6582 11.2107 10.5548 11.2107 10.447C11.2107 10.3392 11.1679 10.2358 11.0916 10.1596L9.94245 9.01094ZM7.35718 9.84375C7.24943 9.84375 7.1461 9.88655 7.06992 9.96274C6.99373 10.0389 6.95093 10.1423 6.95093 10.25V11.875C6.95093 11.9827 6.99373 12.0861 7.06992 12.1623C7.1461 12.2384 7.24943 12.2812 7.35718 12.2812C7.46492 12.2812 7.56825 12.2384 7.64444 12.1623C7.72063 12.0861 7.76343 11.9827 7.76343 11.875V10.25C7.76343 10.1423 7.72063 10.0389 7.64444 9.96274C7.56825 9.88655 7.46492 9.84375 7.35718 9.84375ZM4.7719 9.01094L3.62272 10.1596C3.5465 10.2358 3.50367 10.3392 3.50367 10.447C3.50367 10.5548 3.5465 10.6582 3.62272 10.7345C3.69895 10.8107 3.80234 10.8535 3.91015 10.8535C4.01795 10.8535 4.12134 10.8107 4.19757 10.7345L5.34624 9.58527C5.41921 9.50847 5.45929 9.40619 5.45793 9.30026C5.45658 9.19432 5.41389 9.09311 5.33898 9.0182C5.26407 8.94328 5.16285 8.9006 5.05692 8.89924C4.95098 8.89789 4.84871 8.93797 4.7719 9.01094ZM4.51343 7C4.51343 6.89226 4.47063 6.78892 4.39444 6.71274C4.31825 6.63655 4.21492 6.59375 4.10718 6.59375H2.48218C2.37443 6.59375 2.2711 6.63655 2.19492 6.71274C2.11873 6.78892 2.07593 6.89226 2.07593 7C2.07593 7.10774 2.11873 7.21108 2.19492 7.28726C2.2711 7.36345 2.37443 7.40625 2.48218 7.40625H4.10718C4.21492 7.40625 4.31825 7.36345 4.39444 7.28726C4.47063 7.21108 4.51343 7.10774 4.51343 7ZM4.19757 3.26555C4.12134 3.18932 4.01795 3.14649 3.91015 3.14649C3.80234 3.14649 3.69895 3.18932 3.62272 3.26555C3.5465 3.34178 3.50367 3.44516 3.50367 3.55297C3.50367 3.66077 3.5465 3.76416 3.62272 3.84039L4.7719 4.98906C4.84871 5.06203 4.95098 5.10211 5.05692 5.10076C5.16285 5.0994 5.26407 5.05672 5.33898 4.9818C5.41389 4.90689 5.45658 4.80568 5.45793 4.69974C5.45929 4.59381 5.41921 4.49153 5.34624 4.41473L4.19757 3.26555Z' fill='white'/%3E%3C/svg%3E");
    background-position: center;
    background-repeat: no-repeat;
  }

  li.check,
  li.loading {
    color: #289254;
  }
`;
